<template>
  <form>
    <div>
      <textarea required v-model="text" :placeholder="placeholder"/>
      <ul v-if="errors && errors.length > 0" class="comment-form__errors-list">
        <li v-for="(error, key) in errors"
          :key="key">
          {{ error }}
        </li>
      </ul>
    </div>

    <div :class="['button-wrapper', {blur : isBlurred}]">
      <table align="center">  
        <td><button
          typ="submit"
          class="button"
          :disabled="isSubmitting || !isValid"
          @click="onSubmit">
          <span v-if="isSubmitting">Submitting...</span>
          <span v-else>Submit</span>
        </button> </td>

        <td><button class="button" @click="onCancel">
          Go back
        </button></td>
      </table>
    </div>
  </form>
</template>

<script>
import {createComment} from '@/api/comment'
import {flatten, trim} from 'lodash'

export default {
  name: 'CommentForm',
  props: {
    imageKey: Number,
    placeholder: String,
    isBlurred: Boolean,
    onSubmitted: Function
  },
  data: function() {
    return {
      text: '',
      errors: [],
      isSubmitting: false
    }
  },
  computed: {
    isValid: function () {
      return this.text && this.text.length > 0
    }
  },
  methods: {
    onSubmitStart: function () {
      this.errors = []
      this.isSubmitting = true
    },
    onSubmitSuccess: function () {
      this.errors = []
      this.text = ''
      this.isSubmitting = false
      this.onSubmitted()
    },
    onSubmitFailure: function(err) {
      this.isSubmitting = false
      if(err.response) {
        const {data} = err.response
        this.errors = flatten(
          Object.keys(data).map((x) => `${x}: ${data[x]}`)
        )
      } else {
        this.errors = [err.message]
      }
    },
    onSubmit: async function(e) {
      e.preventDefault()
      this.onSubmitStart()
      try {
        const {imageKey, text} = this
        await createComment({imageKey, text: trim(text)})
        this.onSubmitSuccess()
      } catch(err) {
        this.onSubmitFailure(err)
      }
    },
    onCancel: function(e) {
      e.preventDefault()
      window.close()
    }
  }
}
</script>

<style scoped>
  .comment-form__errors-list {
    list-style: none;
    text-align: center;
  }
  button {
    text-transform: uppercase;
  }
  button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  textarea {
    margin: 1em auto;
    display: block;
    height: 10em;
    width: 30em;
    font-family: 'Overpass Mono', monospace;
    padding: 1em;
  }
  textarea::placeholder {
    color:red;
  }
</style>
